<script setup lang="ts">
const { t } = useI18n()
</script>

<template>
  <div class="app-screen">
    <AppScreensStatusBar :time="t('mock.statusTime')" />

    <div class="app-bar">
      <div class="app-bar__back">‹</div>
      <div class="app-bar__title">{{ t('mock.bank.title') }}</div>
      <div class="app-bar__action app-bar__action--green">👤</div>
      <div class="app-bar__action">↻</div>
    </div>

    <!-- Hero balance card with blue gradient -->
    <div class="app-card app-card--gradient-blue" style="margin-bottom: 8px;">
      <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 8px;">
        <div style="width: 22px; height: 22px; border-radius: 6px; background: rgba(255,255,255,0.15); display: grid; place-items: center; font-size: 11px;">💳</div>
        <span style="font-size: 11px; font-weight: 600;">{{ t('mock.bank.cardLabel') }}</span>
      </div>
      <div style="font-size: 28px; font-weight: 800; letter-spacing: -0.02em; line-height: 1; margin-bottom: 4px;">
        {{ t('mock.bank.amount') }}
      </div>
      <div style="font-size: 10px; opacity: 0.85; margin-bottom: 8px;">{{ t('mock.bank.avail') }}</div>
      <div style="background: rgba(0,0,0,0.25); border-radius: 8px; padding: 6px 9px; font-size: 9.5px; display: flex; align-items: center; gap: 6px;">
        <span>⏳</span><span>{{ t('mock.bank.pending') }}</span>
      </div>
      <div style="font-size: 8.5px; opacity: 0.78; font-family: ui-monospace, monospace; margin-top: 8px;">
        {{ t('mock.bank.account') }}
      </div>
    </div>

    <!-- Fast Bank panel CTA card -->
    <div class="app-card" style="margin-bottom: 8px;">
      <div class="app-card__title">{{ t('mock.bank.panelTitle') }}</div>
      <div class="app-card__hint" style="margin-bottom: 8px;">
        {{ t('mock.bank.panelBody') }}
      </div>
      <button class="app-btn app-btn--green">
        <span>⤴</span><span>{{ t('mock.bank.openBank') }}</span>
      </button>
    </div>

    <!-- Info card -->
    <div class="app-card">
      <div style="display: flex; align-items: center; gap: 6px; margin-bottom: 4px;">
        <span style="color: var(--app-cyan);">ⓘ</span>
        <span style="font-size: 11px; font-weight: 600;">{{ t('mock.bank.infoTitle') }}</span>
      </div>
      <div class="app-card__hint">
        {{ t('mock.bank.infoBody') }}
      </div>
    </div>
  </div>
</template>
